










import HertzStore from '@/classes/Hertz/HertzStore'
import Store from '@/classes/Store'

import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    store: {
      type: Object as PropType<Store | null>,
      default: null,
    },
    /** 帶入 Hertz 的店家 */
    rentStore: {
      type: Object as PropType<HertzStore | null>,
      default: null,
    },
    returnStore: {
      type: Object as PropType<HertzStore | null>,
      default: null,
    },
    rentOrReturn: {
      type: String,
      default: null,
    },
  },
  setup (props) {
    const { store, rentStore, returnStore } = { ...props }

    const place = computed(() => props.rentOrReturn === 'return' ? returnStore : rentStore ?? store)

    const coordinate = computed(() => place.value?.coordinate)

    const embedSrc = computed(() => {
      if (!process.env.GOOGLE_MAPS_API_KEY || !coordinate.value?.lat || !coordinate.value?.lng) return null

      return `https://www.google.com/maps/embed/v1/place?key=${process.env.GOOGLE_MAPS_API_KEY}&q=${coordinate.value.lat},${coordinate.value?.lng}`
    })

    return {
      embedSrc,
    }
  },
})
